import { inject, type InjectionKey } from 'vue';
import type { useAccordionState } from './hooks';

export const accordionKey = Symbol('jk/accordion') as InjectionKey<ReturnType<typeof useAccordionState>>;

export const useAccordion = () => inject(accordionKey);
